export const strokeCapRoundIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 3c-3.175 0-6.975 2.339-6.975 7.033C3.025 13.984 6.227 17 10 17h10v-2H10c-3.851 0-5.003-3.484-5.003-4.968C4.997 8.048 6.392 5 10 5h10V3zM8 8v4h4v-1h8V9h-8V8z"/></svg>`,
  name: 'stroke-cap-round',
};
